/** The advance page form (#5789); the UI holds one trip, so the amount is that trip line's. */
export interface EmployeeAdvanceFormModel {
  amount: number;
  advanceDate: Date | null;
  bankAccount: string | null;
  bankingReference: string | null;
  bankingFee: number | null;
  securityFee: number | null;
  note: string | null;
}

export const employeeAdvanceFieldLabels: Record<keyof EmployeeAdvanceFormModel, string> = {
  amount: 'EmployeeAdvance_Field_Amount',
  advanceDate: 'EmployeeAdvance_Field_Date',
  bankAccount: 'BankCharges_BankAccount',
  bankingReference: 'BankCharges_Reference',
  bankingFee: 'BankCharges_BankingFee',
  securityFee: 'BankCharges_SecurityFee',
  note: 'EmployeeAdvance_Field_Note',
};
